import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared/state';

import {
  InstructionList,
  InstructionListItem,
  InstructionsIntroText,
  InstructionsLink,
} from './csv-upload-instructions.styled';

export type CsvUploadInstructionsProps = {
  exampleCsvName?: string;
  templateCsvName?: string;
  templateCsvUrl?: string;
  exampleCsvUrl?: string;
  title: string;
};

export const CsvUploadInstructions = ({
  exampleCsvName = 'csv-upload-example.csv',
  exampleCsvUrl,
  templateCsvName = 'csv-upload-template.csv',
  templateCsvUrl,
  title,
}: CsvUploadInstructionsProps): React.ReactElement => {
  const manualCsvTemplateDownloadLinkId = useAnalyticId(AnalyticIdentifier.RTC_CSV_UPLOAD_TEMPLATE_DOWNLOAD_LINK);
  const manualCsvExampleDownloadLinkId = useAnalyticId(AnalyticIdentifier.RTC_CSV_UPLOAD_EXAMPLE_DOWNLOAD_LINK);

  return (
    <>
      <InstructionsIntroText as="span" fontSize="sm" fontWeight="normal">
        {title}
      </InstructionsIntroText>
      <InstructionList $listStyle="decimal">
        {templateCsvUrl && (
          <InstructionListItem>
            Download the template{' '}
            <InstructionsLink
              target="_blank"
              download={templateCsvName}
              href={templateCsvUrl}
              id={manualCsvTemplateDownloadLinkId}
            >
              here
            </InstructionsLink>{' '}
            and a pre-filled example{' '}
            <InstructionsLink
              target="_blank"
              download={exampleCsvName}
              href={exampleCsvUrl}
              id={manualCsvExampleDownloadLinkId}
            >
              here
            </InstructionsLink>
            .
          </InstructionListItem>
        )}
        <InstructionListItem>Fill out the template spreadsheet.</InstructionListItem>
        <InstructionListItem>Drag and drop the filled spreadsheet.</InstructionListItem>
      </InstructionList>
    </>
  );
};
